import { render, staticRenderFns } from "./cSocAnalSocNet.vue?vue&type=template&id=3bb8bb96&scoped=true&"
import script from "./cSocAnalSocNet.vue?vue&type=script&lang=js&"
export * from "./cSocAnalSocNet.vue?vue&type=script&lang=js&"
import style0 from "./cSocAnalSocNet.vue?vue&type=style&index=0&id=3bb8bb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8bb96",
  null
  
)

export default component.exports